import React from 'react';
import objectPath from 'object-path';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

/* eslint-disable indent */
const Seo = ({ seo }) => (
  seo
    ?
      <Helmet
        title={objectPath.get(seo, 'fields.pageTitle')}
        meta={[
          objectPath.has(seo, 'fields.pageDescription') && {
            name: 'description',
            content: seo.fields.pageDescription,
          },
          objectPath.has(seo, 'fields.openGraphDescription') && {
            property: 'og:description',
            content: seo.fields.openGraphDescription,
          },
          objectPath.has(seo, 'fields.openGraphDescription') && {
            name: 'twitter:description',
            content: seo.fields.openGraphDescription,
          },
          objectPath.has(seo, 'fields.pageTitle') && {
            property: 'og:title',
            content: seo.fields.pageTitle,
          },
          objectPath.has(seo, 'fields.pageTitle') && {
            name: 'twitter:title',
            content: seo.fields.pageTitle,
          },
          objectPath.has(seo, 'fields.openGraphImage.fields.file.url') && {
            property: 'og:image',
            content: `https:${seo.fields.openGraphImage.fields.file.url}?w=1200&h=630&fit=thumb&f=center`,
          },
          objectPath.has(seo, 'fields.openGraphImage.fields.file.url') && {
            property: 'twitter:image',
            content: `https:${seo.fields.openGraphImage.fields.file.url}?w=1200&h=630&fit=thumb&f=center`,
          },
        ].filter(Boolean)}
      />
    :
      null
);

Seo.propTypes = {
  seo: PropTypes.object,
};

export default Seo;
